:host {
    @include scrollbar;

    display: none;
    position: absolute;
    flex-direction: column;
    background-color: var(--color-background-interaction-secondary-inverted);
    box-shadow: var(--shadow-large);
    border: 1px solid var(--color-border-interaction-default);
    min-width: 100%;
    overflow: hidden;
    z-index: 2147483600;

    ::slotted(*:not(:first-of-type)) {
        border-top: 1px solid var(--color-border-separator-primary);
    }
}

::slotted(sew-menu-item) {
    @include font-p-default;

    color: var(--color-text-default);
}

::slotted(*) {
    cursor: pointer;
    padding: var(--form-combo-box-padding-vertical, 12px) var(--form-padding-horizontal, 12px);
    white-space: nowrap;
}

::slotted(sew-menu-item[role='presentation']) {
    @include font-p-bold;

    color: var(--color-text-default);
}

::slotted(sew-menu-item.sew-menu-item--custom-input),
::slotted(sew-menu-item.sew-menu-item--custom-option) {
    padding-right: 0;
}

::slotted(sew-menu-item[role='presentation']:not(:first-of-type):not(.sew-menu-item--custom-input)) {
    padding-top: 16px;
}

:host(.wrap) {
    ::slotted(*) {
        white-space: normal;
    }
}

::slotted(*:hover) {
    background-color: var(--color-overlay-secondary-hover);
}

::slotted(*:active),
::slotted(*.sew-menu-item--selected) {
    background-color: var(--color-overlay-secondary-active);
}

::slotted(*:focus),
::slotted(*:focus-visible) {
    outline: 2px solid var(--color-border-interaction-focus);
    outline-offset: -2px;
}

:host([open]) {
    display: flex;
}

:host(.open-animation) {
    animation: slideOpen 0.2s ease-out forwards;
}

:host(.sew-ws) {
    background-color: var(--background-color, #{$color-white});

    ::slotted(*:not(:last-of-type)) {
        border-bottom: 1px solid var(--option-border-color, #{$color-grey-05-light});
    }

    ::slotted(sew-menu-item) {
        @include typo-ws-paragraph;

        color: var(--option-color, #{$color-grey-02-steel});
        padding: 16px 20px;
    }

    ::slotted(sew-ws-link) {
        padding: 16px 12px;
    }

    ::slotted(sew-menu-item.sew-menu-item--selected) {
        @include typo-ws-paragraph-bold;

        outline: none;
        color: var(--input-color, #{$color-grey-01-dark});
        background-color: inherit;
    }

    ::slotted(*:hover) {
        background-color: var(--option-hover-background-color, #{$color-grey-06-bright});
    }

    ::slotted(sew-menu-item:hover) {
        @include typo-ws-paragraph-bold;

        color: var(--input-color, #{$color-grey-01-dark});
    }

    ::slotted(*:focus),
    ::slotted(*:focus-visible) {
        outline: 2px solid var(--color-outline, #{$color-grey-04-middle});
    }
}

@keyframes slideOpen {
    from {
        max-height: 0;
        overflow: hidden;
    }

    99% {
        overflow: hidden;
    }

    to {
        max-height: var(--list-max-height);
        overflow: hidden auto;
    }
}
